module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/instagram-second-step-62b5fc27f26c18a9ddd7a4c4f98abe99.png";